/* eslint-disable import/no-webpack-loader-syntax */

module.exports = {
  footer: require('!ejs-compiled-loader!./footer.ejs'),
  footer_activities: require('!ejs-compiled-loader!./footer_activities.ejs'),
  footer_activities_empty: require('!ejs-compiled-loader!./footer_activities_empty.ejs'),
  footer_activity: require('!ejs-compiled-loader!./footer_activity.ejs'),
  header: require('!ejs-compiled-loader!./header.ejs'),
  header_club: require('!ejs-compiled-loader!./header_club.ejs'),
  header_dates: require('!ejs-compiled-loader!./header_dates.ejs'),
  header_dates_groups: require('!ejs-compiled-loader!./header_dates_groups.ejs'),
  header_filter: require('!ejs-compiled-loader!./header_filter.ejs'),
  header_filters: require('!ejs-compiled-loader!./header_filters.ejs'),
  header_hour: require('!ejs-compiled-loader!./header_hour.ejs'),
  layout: require('!ejs-compiled-loader!./layout.ejs'),
  main_booking: require('!ejs-compiled-loader!./main_booking.ejs'),
  main_booking_special: require('!ejs-compiled-loader!./main_booking_special.ejs'),
  main_booking_tooltip: require('!ejs-compiled-loader!./main_booking_tooltip.ejs'),
  main_hour: require('!ejs-compiled-loader!./main_hour.ejs'),
  main_section: require('!ejs-compiled-loader!./main_section.ejs'),
  popup_footer: require('!ejs-compiled-loader!./popup_footer.ejs'),
  popup_footer_activities_empty: require('!ejs-compiled-loader!./popup_footer_activities_empty.ejs'),
  popup_footer_activity: require('!ejs-compiled-loader!./popup_footer_activity.ejs'),
  popup_footer_actually: require('!ejs-compiled-loader!./popup_footer_actually.ejs'),
  popup_footer_next: require('!ejs-compiled-loader!./popup_footer_next.ejs')
};



// WEBPACK FOOTER //
// ./src/templates/index.js